import { render, staticRenderFns } from "./MailSettingsRenameModal.vue?vue&type=template&id=b16e6ea6"
import script from "./MailSettingsRenameModal.vue?vue&type=script&lang=ts"
export * from "./MailSettingsRenameModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b16e6ea6')) {
      api.createRecord('b16e6ea6', component.options)
    } else {
      api.reload('b16e6ea6', component.options)
    }
    module.hot.accept("./MailSettingsRenameModal.vue?vue&type=template&id=b16e6ea6", function () {
      api.rerender('b16e6ea6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/MailSettingsRenameModal.vue"
export default component.exports